import { createContext, useContext, type FC, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type CallPopUpGlobalStore } from 'widgets/CallPopUp/store/callPopUpGlobalStore'

export const CallPopUpGlobalContext = createContext<CallPopUpGlobalStore | null>(null)

export function useCallPopUpGlobalContext() {
  const context = useContext(CallPopUpGlobalContext)
  if (context === null) {
    throw new Error(
      'You have forgotten to wrap your root component with CallPopUpDefaultStoreProvider'
    )
  }
  return context
}

type IProviderCallPopUpGlobalProps = {
  children: ReactNode
  value: CallPopUpGlobalStore
}

export const ProviderCallPopUpGlobal: FC<IProviderCallPopUpGlobalProps> = observer(
  ({ children, value }) => {
    return (
      <CallPopUpGlobalContext.Provider value={value}>{children}</CallPopUpGlobalContext.Provider>
    )
  }
)
